export function returnOnCondition<T>(
  condition: boolean,
  output: T,
): T | undefined;

export function returnOnCondition<T, D>(
  condition: boolean,
  output: T,
  defaultValue: D,
): T | D;

export function returnOnCondition<T, D>(
  condition: boolean,
  output: T,
  defaultValue?: D,
): T | D | undefined {
  if (condition) return output;
  return defaultValue;
}
